<template>
  <div name="cpd">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Continuing Professional Development</h2>
      </div>

    </header>


    <div class="w-full h-20 ml-8">
        <p>
          Continuing Professional Development is a commitment to ongoing learning and training. <br />
          PE Passport along with educational partners are currently developing a range of resources and courses to assist schools and PE leads with professional learning and development.
        </p>
      </div>

      <section class="ml-12 mb-12">
      <div
        class="
          max-w-sm
          bg-white
          border border-gray-200
          rounded-lg
          shadow
          dark:bg-gray-800 dark:border-gray-700
        "
      >
      <a
      href="https://dancetoschool.com/#cpd"
            target="_blank"
            class="hover:opacity-75">
   
          <img
            class="rounded-t-lg"
            src="/static/images/d2s-advert.png"
            alt=""
          />

        <div class="p-5">

            <h5
              class="
                mb-2
                text-2xl
                font-bold
                tracking-tight
                text-gray-900
                dark:text-white
              "
            >
              Dance 4 Schools
            </h5>
  
          <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">
            Our flexible, cost effective online training course brings to life a digital version of our face to face training at a time and place to suit each individual member of staff.
          </p>
          <div

            class="
              inline-flex
              items-center
              py-2
              text-sm
              font-semibold
              text-center text-action-blue
              focus:ring-4 focus:outline-none focus:ring-blue-300
            "
          >
            Read more (external link)    <i class="fas fa-caret-right ml-3 text-base  text-action-blue"></i>
        
        </div>

        </div>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "cpd",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style scoped>
</style>